import { injectable } from '@servicetitan/react-ioc';
import { action, computed, makeObservable, observable } from 'mobx';

@injectable()
export class ProposalDrawerStore {
    @observable proposalId?: string;

    @computed get isOpen() {
        return !!this.proposalId;
    }

    constructor() {
        makeObservable(this);
    }

    @action
    open = (proposalId: string) => {
        this.proposalId = proposalId;
    };

    @action
    close = () => {
        this.proposalId = undefined;
    };
}
